import React from 'react';
import { Route, Routes as Switch, unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import { RichIconTypes } from '@eika/rich-icon';

import { StringKeyValue } from './actions/types';
import ErrorMessage from './components/Messages/ErrorMessage';
import GlobalLoader from './containers/GlobalLoader';
import LoanApplication from './containers/LoanApplication/LoanApplication';
import LoanCalculatorContainer from './containers/LoanCalculator/LoanCalculatorContainer';
import VehicleTypeSelector from './containers/LoanCalculator/VehicleTypeSelector/VehicleTypeSelector';
import LoanCompletion from './containers/LoanCompletion/LoanCompletion';
import LoanUpgrade from './containers/LoanUpgrade/LoanUpgrade';
import LoanUpgradeSuccess from './containers/LoanUpgrade/LoanUpgradeSuccess';
import OngoingApplications from './containers/OngoingApplications/OngoingApplications';
import LoanApplicationReceipt from './containers/Receipts/LoanApplicationReceipt';
import customHistory from './customHistory';
import { useAppSelector } from './hooks/redux';
import RoutePath from './util/mappings/routePath';

const Routes: React.FC = () => {
    const maintenanceMessage =
        'Hei! På grunn av teknisk vedlikehold og oppgraderinger er løsningen for øyeblikket utilgjengelig. Vi jobber med å få den opp igjen så raskt som mulig. Vennligst prøv igjen om noen timer.';
    const appType = useAppSelector((state) => state.context.appType);
    const text = useAppSelector((state) => state.context.config.data.text as StringKeyValue);
    const isUnavailable = useAppSelector((state) => state.feature.salgspantUnavailable);

    if (isUnavailable) {
        return (
            // @ts-ignore
            <HistoryRouter history={customHistory}>
                <Switch>
                    <Route
                        path="*"
                        element={
                            <ErrorMessage
                                title="Midlertidig utilgjengelig"
                                textList={[maintenanceMessage]}
                                icon={RichIconTypes.HJERTE_GLINSER}
                            />
                        }
                    />
                </Switch>
            </HistoryRouter>
        );
    }

    if (appType === 'landing') {
        return (
            // @ts-ignore
            <HistoryRouter history={customHistory}>
                <Switch>
                    <Route
                        path="/"
                        element={
                            <GlobalLoader key="1" secure>
                                <OngoingApplications />
                            </GlobalLoader>
                        }
                    />
                    <Route path={RoutePath.loanUpgrade} element={<LoanUpgrade />} />
                    <Route path={RoutePath.loanUpgradeSuccess} element={<LoanUpgradeSuccess />} />

                    <Route
                        path="*"
                        element={
                            <ErrorMessage
                                title={text.pageNotFoundTitle}
                                textList={[text.pageNotFoundText1, text.pageNotFoundText2, text.pageNotFoundText3]}
                                infoBox={text.defaultInfoBoxText}
                            />
                        }
                    />
                </Switch>
            </HistoryRouter>
        );
    }

    return (
        // @ts-ignore
        <HistoryRouter history={customHistory}>
            <Switch>
                {/* Root Component */}
                <Route
                    path="/"
                    element={
                        <GlobalLoader key="1" secure={appType !== 'calculator'}>
                            {appType === 'calculator' && <VehicleTypeSelector text={text} />}
                            {appType === 'application' && <LoanApplication />}
                            {appType === 'completion' && <LoanCompletion />}
                        </GlobalLoader>
                    }
                />
                {/* Calculator: Select Vehicle */}
                <Route
                    path={RoutePath.calculator}
                    element={
                        <GlobalLoader key="2" secure={false}>
                            <VehicleTypeSelector text={text} />
                        </GlobalLoader>
                    }
                />
                {/* Calculator: Product */}
                <Route
                    path={RoutePath.calculatorProduct}
                    element={
                        <GlobalLoader key="3" secure={false}>
                            <LoanCalculatorContainer />
                        </GlobalLoader>
                    }
                />
                {/* Application */}
                <Route
                    path={RoutePath.application}
                    element={
                        <GlobalLoader key="5" secure>
                            <LoanApplication />
                        </GlobalLoader>
                    }
                />
                {/* Receipt */}
                <Route
                    path={RoutePath.applicationReceipt}
                    element={
                        <GlobalLoader key="6" secure>
                            <LoanApplicationReceipt />
                        </GlobalLoader>
                    }
                />
                {/* Loan Completion */}
                <Route
                    path={RoutePath.completion}
                    element={
                        <GlobalLoader key="7" secure>
                            <LoanCompletion />
                        </GlobalLoader>
                    }
                />
                <Route
                    path={RoutePath.loanUpgrade}
                    element={
                        <GlobalLoader key="8" secure>
                            <LoanUpgrade />
                        </GlobalLoader>
                    }
                />
                <Route
                    path={RoutePath.loanUpgradeSuccess}
                    element={
                        <GlobalLoader key="9" secure>
                            <LoanUpgradeSuccess />
                        </GlobalLoader>
                    }
                />

                <Route
                    path="*"
                    element={
                        <ErrorMessage
                            title={text.pageNotFoundTitle}
                            textList={[text.pageNotFoundText1, text.pageNotFoundText2, text.pageNotFoundText3]}
                            infoBox={text.defaultInfoBoxText}
                        />
                    }
                />
            </Switch>
        </HistoryRouter>
    );
};

export default Routes;
